import { UserInfoModel, AddressesUserProfileModel } from '../profile/profile.model';

import { CartInfoModel } from './cart-info-model';
import { UserModel } from '../user.model';
import { PreApprovalDetail } from './pre-approval.model';

export class CartAndProfileModel {
    cart: CartInfoModel;
    profile: UserInfoModel;
    user: UserModel;
    addresses: AddressesUserProfileModel[];
    preApprovalDetail?: PreApprovalDetail;
}



// WEBPACK FOOTER //
// ./src/app/model/checkout/cart-profile.model.ts